export default {
    bind: el => {
        if (el.querySelector('a[href]') === null) {
            // Directive v-data-href set on element that does not contain an A element.
            return;
        }

        el.classList.add('cursor-pointer');

        el.addEventListener('click', event => {
            // Usage: v-data-href on parent element (previously data-href)
            if (event.target.tagName === 'A' && event.target.getAttribute('href')) {
                // Just follow a when clicked on it
                return;
            }

            let a = el.querySelector('a');

            if (a) {
                let target = a.getAttribute('target');

                if (typeof target !== typeof undefined && target) {
                    window.open(a.getAttribute('href'), target);
                } else {
                    location.href = a.getAttribute('href');
                }
            }
        });
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/directives/dataHref.js